import type { PortalUnitTotal } from "@wms/domain";
import { formatQty } from "../api/format";

/** CW31-B02: «160 шт · 2,5 кг» — one number per unit, never pieces and kilograms added up. */
export function unitTotalsText(totals: PortalUnitTotal[], key: "plan" | "fact"): string {
  return totals.map((t) => `${formatQty(t[key])} ${t.unit}`).join(" · ");
}

/** CW31-B02: «1 кг из 2,5 кг; 0 шт из 160 шт» — the fact of every unit against its own plan. */
export function unitProgressText(totals: PortalUnitTotal[]): string {
  return totals.map((t) => `${formatQty(t.fact)} ${t.unit} из ${formatQty(t.plan)} ${t.unit}`).join("; ");
}

/** CW31-B02: «строк: 1 из 4» — the progress of a document whatever its units; empty when the server did not say. */
export function linesProgressText(done?: number, total?: number): string {
  return total ? `строк: ${done ?? 0} из ${total}` : "";
}

export const DISPUTE_REASON_MAX = 2000;

/** CW31-B14: what is wrong with the explanation of «Не согласен» — the same rule as the server (trimmed, 3–2000). */
export function disputeReasonProblem(text: string | undefined | null): string | null {
  const value = (text ?? "").trim();
  if (!value) return "Укажите пояснение к обращению";
  if (value.length < 3) return "Не короче 3 символов: дополните пояснение";
  if (value.length > DISPUTE_REASON_MAX) return `Не длиннее ${DISPUTE_REASON_MAX} символов (сейчас ${value.length}): сократите текст`;
  return null;
}

/** CW31-B10: the colour of a dispute status in the cabinet — waiting, on review, decided, declined. */
export const DISPUTE_COLORS: Record<string, string> = { open: "default", in_review: "processing", resolved: "green", declined: "red" };
